<template>
	<div>
		<v-tooltip bottom>
			<template #activator="{ on, attrs }">
				<v-icon
					v-bind="attrs"
					v-on="on"
					@click="open = true"
				>
					{{ icons.mdiGift }}
				</v-icon>
			</template>
			<span>{{ $t('network.wall.grants.modal.send_pixels') }}</span>
		</v-tooltip>

		<modal-create-grant
			hide-activator
			:force-open="open"
			@close="open = false"
			@parent-function="open = false"
		/>
	</div>
</template>

<script>
import { mdiGift } from '@mdi/js'
import ModalCreateGrant from '@/views/network/wall/grants/modalCreate.vue'

export default {
	components: { ModalCreateGrant },
	data() {
		return {
			open: false,
			icons: { mdiGift },
		}
	},
}
</script>
